import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'

export default function HeaderLogo() {
    const navigate = useNavigate()
    return (
        <Box component={"img"}
            sx={{ cursor: 'pointer' }}
            onClick={()=>navigate('/')}
            ml={"25px"}  
            height="72px"
            width="148px"
            loading="lazy"
            alt="Solar Zero Logo"
            src="/images/szNamedLogo.svg" />
    )
}